function initSliderRelatedProduct() {
  var featuredProduct = $("[data-related-products-slider]");

  featuredProduct.each(function () {
    var self = $(this),
      productGrid = self.find(".products-grid"),
      gridItemWidth = productGrid.data("row"),
      hasRightSidebar = $(
        ".halo-product-content .pro-page [data-has-right-sidebar]"
      );

    if (productGrid.not(".slick-initialized")) {
      productGrid.slick({
                        infinite: false,
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        speed: 1000,
                        slidesToShow: gridItemWidth,
                        get dots() {
                                return this.dots = false;
                        },
                        slidesToScroll: gridItemWidth,
                        get nextArrow() {
                            return this.nextArrow = '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>';
                      },
                        get prevArrow() {
                            return this.prevArrow = '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>';
                        },
                        responsive:  [
                          {
                            breakpoint: 1024,
                            settings: {
                              slidesToShow: 2,
                              slidesToScroll: 2,
                            }
                          },
                          {
                            breakpoint: 760,
                            settings: {
                              slidesToShow: 1,
                              slidesToScroll: 1
                            }
                          }
                        ]
                        });
    }
  });
}




try {
  var $container = $(".js-product-recomendation");
  var productId = $container.data("productId");
  var template = $container.data("template");
  var sectionId = $container.data("sectionId");
  var limit = $container.data("limit");
  var productRecommendationsUrlAndContainerClass =
    window.router +
    "/recommendations/products?&section_id=" +
    sectionId +
    "&limit=" +
    limit +
    "&product_id=" +
    productId +
    " .product-recommendations";
  $container
    .parent()
    .load(productRecommendationsUrlAndContainerClass, function () {
      try {
      $('[data-toggle="tooltip"]').tooltip({container: 'body'});  
      } catch (error) {}
      if (template != "") {
        $(".js-product-recomendation .products-grid").addClass("verticle");
      }
      initSliderRelatedProduct();
      
    });

} catch(e)
{
    console.log(e);        
}

